let lazyImageObserver: IntersectionObserver | null = null;
let lazyBackgroundObserver: IntersectionObserver | null = null;

if ("IntersectionObserver" in window) {
  lazyImageObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const lazyImage = entry.target as HTMLImageElement;
        lazyImage.src = lazyImage.dataset.src!;
        //lazyImage.attributes.removeNamedItem("data-src");
        if (lazyImage.dataset.srcset) {
          lazyImage.srcset = lazyImage.dataset.srcset;
          //lazyImage.attributes.removeNamedItem("data-srcset");
        }
        lazyImage.classList.remove("lazy");
        lazyImageObserver?.unobserve(lazyImage);
      }
    });
  });
  lazyBackgroundObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const element = entry.target as HTMLElement;

        let src = element.dataset.background;

        if (
          element.dataset.backgroundretina &&
          "devicePixelRatio" in window &&
          window.devicePixelRatio > 1
        ) {
          src = element.dataset.backgroundretina;
        }

        element.style.backgroundImage = `url(${src})`;

        lazyBackgroundObserver?.unobserve(entry.target);
      }
    });
  });
}

export function hookLazyLoading(el: ParentNode) {
  const lazyImages = [].slice.call(el.querySelectorAll("img[data-src]"));

  if (lazyImageObserver && lazyBackgroundObserver) {
    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver?.observe(lazyImage);
    });
  } else {
    lazyImages.forEach(function (lazyImage: HTMLImageElement) {
      lazyImage.src = lazyImage.dataset.src!;
    });
  }

  const lazyBackgrounds = [].slice.call(
    el.querySelectorAll("[data-background]")
  );

  if (lazyImageObserver && lazyBackgroundObserver) {
    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver?.observe(lazyBackground);
    });
  } else {
    lazyBackgrounds.forEach(function (lazyBackground: HTMLElement) {
      lazyBackground.style.backgroundImage = `url(${lazyBackground.dataset.background})`;
    });
  }
}
